export default __webpack_public_path__ + "static/media/coach-bundle_white@2x.0a68328b.jpg";